import { formatNumber } from 'libphonenumber-js/custom';
import metadata from '../../../metadata.min.json';

export default function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return phoneNumber;
  }

  return formatNumber(phoneNumber, 'International', metadata) || phoneNumber;
}
